import { render, staticRenderFns } from "./InstagramAndPress.vue?vue&type=template&id=5a0ffedf&scoped=true&"
import script from "./InstagramAndPress.vue?vue&type=script&lang=js&"
export * from "./InstagramAndPress.vue?vue&type=script&lang=js&"
import style0 from "./InstagramAndPress.vue?vue&type=style&index=0&id=5a0ffedf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0ffedf",
  null
  
)

export default component.exports